// The standard dialog: title, close button, an error line, body and footer.
//
// Defined at module level, never inside a component — a component declared
// inside its parent is a new type on every render, so React remounts it on
// each keystroke and the focused input loses focus. Staff and Access Control
// each carried an identical copy of this (2026-10-19); a page that needs a
// dialog should use this one rather than add a third.
const Modal = ({ show, onClose, title, children, footer, error }) => {
  if (!show) return null;
  return (
    <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" onMouseDown={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {error && <div style={{ background:'var(--danger-bg)', border:'0.5px solid var(--danger-border)', borderRadius:8, padding:'10px 14px', marginBottom:14, fontSize:12, color:'var(--danger)' }}>{error}</div>}
          {children}
        </div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
